import React from 'react';

const ModalBody = ({ title, subtitle, children, footer, className = '' }) => {
  return (
    <div className={`ui-modal-surface-light ui-modal-surface-wide ${className}`.trim()}>
      {(title || subtitle) ? (
        <div className="ui-modal-header">
          {title ? <h2 className="AppFont ui-modal-form-title">{title}</h2> : null}
          {subtitle ? <div className="ui-modal-subtitle">{subtitle}</div> : null}
        </div>
      ) : null}
      <div className="ui-modal-content">{children}</div>
      {footer ? <div className="ui-modal-footer">{footer}</div> : null}
    </div>
  );
};

export default ModalBody;
